import { CustomFormattedMessage, TranslationsKeys } from '../i18n/i18n';
import RioNotification from '@rio-cloud/rio-uikit/Notification';
import { ReactNode } from 'react';

const NOTIFICATION_TIMEOUT = 999999;

export const notifyDismissible = (
  type: keyof typeof RioNotification,
  body: ReactNode,
  title?: TranslationsKeys,
) => {
  RioNotification[type](
    <span data-testid="dismissible-info-notification">
      {body}
      <span className="notification-close">
        <span className="rioglyph rioglyph-remove" />
      </span>
    </span>,
    {
      title: title ? <CustomFormattedMessage id={title} /> : undefined,
      timeout: NOTIFICATION_TIMEOUT,
    },
  );
};
